export default {
  validity: 'Validity',
  validityTooltip: 'When valid, the {strategy} will be visible in {matrix}.',
}
